import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import {
  Children,
  Fragment,
  cloneElement,
  createElement,
  useEffect,
  useState,
} from 'react';

import TableCellExpandable from '../TableCellExpandable';
import TableRow from '../TableRow';
import TableRowCollapse from './components/TableRowCollapse';

const COMPONENTS_CONFIG = {
  ROW: Fragment,
  ROW_DATA: TableRow,
  ROW_HIDDEN: TableRowCollapse,
  CELL: TableCellExpandable,
};

const TableRowExpan = ({ children, className, expand = false }) => {
  const [expanded, setExpanded] = useState(false);
  const { cx } = useStyles();

  const toggle = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    setExpanded(expand);
  }, [expand]);

  const render = children({
    toggle,
    expanded,
    Row: COMPONENTS_CONFIG.ROW,
    RowData: COMPONENTS_CONFIG.ROW_DATA,
    RowHidden: COMPONENTS_CONFIG.ROW_HIDDEN,
  });

  let Main;
  let Hidden;

  Children.forEach(Children.toArray(render)[0].props.children, (child) => {
    if (child.type === COMPONENTS_CONFIG.ROW_HIDDEN) {
      // Hidden component become TableRowCollapse
      Hidden = child;
    } else if (child.type === COMPONENTS_CONFIG.ROW_DATA) {
      // Main component become TableRow
      Main = cloneElement(child, {
        ...child.props,
        children: Children.map(child.props.children, (mainChild) =>
          createElement(COMPONENTS_CONFIG.CELL, {
            // TableCell child in TableRow become TableCellExpandable
            ...mainChild.props,
            isOpen: expanded,
          })
        ),
      });
    }
  });

  const colSpan = Children.count(Main.props.children);

  return (
    <>
      {cloneElement(Main, { className: cx(Main.props?.className, className) })}
      {cloneElement(Hidden, {
        visible: expanded,
        colSpan,
        className: cx(Hidden.props?.className, className),
      })}
    </>
  );
};

TableRowExpan.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
  expand: PropTypes.bool,
};

export default TableRowExpan;
